import React from 'react'
import "./InnerPageHeader.css"
import { Container } from "react-bootstrap";
import { Link } from 'react-router-dom';

const InnerPageHeader = ({ path = [], title }) => {
  
  const generatePathLinks = () => {
    let accumulatedPath = '';
    return path.map((segment, index) => {
      accumulatedPath += `/${segment.toLowerCase().replace(/\s+/g, '-')}`;
      const isLast = index === path.length - 1;

      return (
        <span key={index}>
          {!isLast ? (
            <>
              <Link to={accumulatedPath} className="about-link">
                <span>{segment}</span>
              </Link>
              {" / "}
            </>
          ) : (
            <span>{segment}</span>
          )}
        </span>
      );
    });
  };

  return (
    <div className="hero-img">
      <Container>
        <div className="about-div">
          <div className="about-link">
            {generatePathLinks()}
          </div>
          <div className="about-title">{title}</div>
        </div>
      </Container>
    </div>
  );
}

export default InnerPageHeader